import { useEffect } from "react";
import { Button } from "../components/Button";
import { getConfig } from "../config";
import { getUserManager } from "./userManager";

/** Post-logout landing: clears the local OIDC state the direct logout redirect left behind. */
export function LoggedOutPage() {
  useEffect(() => {
    if (getConfig().AUTH_ENABLED) void getUserManager().removeUser();
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-6">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-lg">
        <img src="/horizontal-optimyl-logo-black-text.svg" alt="Optimyl" className="mx-auto mb-6 h-8" />
        <h1 className="mb-2 text-2xl font-bold text-brand-navy">Signed out</h1>
        <p className="mb-6 text-gray-600">You have been signed out of UW Workbench.</p>
        <Button onClick={() => window.location.assign("/")}>Sign in again</Button>
      </div>
    </div>
  );
}
